import $ from '@rover/globals/jquery';

function init() {
  const $gusTips = $('.js-gus-tip');
  $gusTips.each(function() {
    const $this = $(this);
    const shouldShow = $.cookie($this.data('gus-tip-cookie')) !== 'dismissed';
    if (shouldShow) {
      $this.show();
    }
  });
}

function handleGusTipDismiss() {
  const $gusTip = $(this).closest('.js-gus-tip');
  $.cookie($gusTip.data('gus-tip-cookie'), 'dismissed', { expires: 180 });
  $gusTip.hide();
}

export default {
  init,
  handleGusTipDismiss,
};



// WEBPACK FOOTER //
// ../utilities/gus-tips.js